import { ErrorLogger } from './ErrorLogger';
import { SentryLogger } from './SentryLogger';

const logger: ErrorLogger = new SentryLogger();

export default logger;
